import {
  ControlContainer,
  NG_VALUE_ACCESSOR,
  FormControlDirective,
  ControlValueAccessor,
  FormControl
} from '@angular/forms';
import {Component, forwardRef, Input, ViewChild} from '@angular/core';
import { BaseUiFormControl } from '../base-ui-form-control';

@Component({
  selector: 'ui-number',
  templateUrl: './ui-number.component.html',
  styleUrls: ['./ui-number.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting:  forwardRef(() => UiNumberComponent),
    multi: true
  }]
})
export class UiNumberComponent extends BaseUiFormControl implements ControlValueAccessor {
  @Input() max?: number;
  @Input() min?: number;
  @Input() placeholder: string = undefined;
  
  constructor(controlContainer: ControlContainer) {
    super(controlContainer);
  }

  get value() {
    return this.control.value;
  }
  set value(value) {
    this.onChange(value);
    this.onTouched();
  }
  onChange: any = () => {};
  onTouched: any = () => {};
  registerOnChange(fn) {
    this.onChange = fn;
  }
  writeValue(value) {
    if (value) {
      this.value = value;
    }

    if (value === null) {
      //this.control.reset();
    }
  }
  setDisabledState(isDisabled: boolean): void {
    if(isDisabled)
      this.control.disable();
    else
      this.control.enable();
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  validate(_: FormControl) {
    return this.control.valid ? null : { profile: { valid: false } };
  }
  clear() {
    this.writeValue(null);
    //this.control.setValue(null);
  }
}
